// 是否显示HeaderTab,HeaderSearch
const routes = [
  {
    path: '/',
    name: 'home',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/home')
  },
  {
    path: '/details',
    name: 'details',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/home/details')
  },
  {
    path: '/search/details',
    name: 'search-details',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/Search/Details')
  },
  {
    path: '/my',
    name: 'my',
    meta: { showFooter: false, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/my/index')
  },
  {
    path: '/travelNotes',
    name: 'travelNotes',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/travelNotes/index')
  },
  {
    path: '/travelNotes/details',
    name: 'Details',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/travelNotes/details')
  },
  {
    path: '/childClassification',
    name: 'childClassification',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/childClassification/index')
  },
  {
    path: '/hotSearch',
    name: 'hotSearch',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/childClassification/HotSearch')
  },
  {
    path: '/hallFame',
    name: 'hallFame',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/hallFame/index')
  },
  {
    path: '/reserve',
    name: 'reserve',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/reserve/index')
  },
  {
    path: '/CreateOrder',
    name: 'CreateOrder',
    meta: { showFooter: false, HeaderTab: false, HeaderSearch: false },
    component: () => import('../views/order/CreateOrder')
  },
  {
    path: '/shopPing',
    name: 'shopPing',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/shopPing/index')
  },
  {
    path: '/shopPing/Details',
    name: 'shopPingDetails',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/shopPing/details')
  },
  {
    path: '/shopPing/order',
    name: 'shopPingOrder',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/shopPing/order')
  },
  {
    path: '/shopPing/Cart',
    name: 'shopPingCart',
    meta: { showFooter: true, HeaderTab: true, HeaderSearch: true },
    component: () => import('../views/shopPing/Cart')
  },
  {
    path: '/pay',
    name: 'pay',
    meta: {
      showFooter: true,
      HeaderTab: false,
      HeaderSearch: false,
      showFooterTab: true // 是否不显示底部TAB选项
    },
    component: () => import('../views/pay/index')
  },
  {
    path: '/Transfer',
    name: 'Transfer',
    meta: {
      showFooter: false,
      HeaderTab: false,
      HeaderSearch: false,
      HeaderBox: true
    },
    component: () => import('../views/pay/Transfer')
  },
  {
    path: '/default',
    name: 'default',
    meta: {
      showFooter: false,
      HeaderTab: false,
      HeaderSearch: false,
      HeaderBox: true
    },
    component: () => import('../views/home/default')
  }
]

export default routes
